export default class DeviceModel {

  allByBuilding({store: $store}, buildingId) {
    return $store.dispatch('apiResult', {
      method: 'GET',
      path: `api/user-buildings/${buildingId}/device-models`,
      path_template: '/api/user-buildings/{building_id}/device-models',
      building_id: buildingId
    });
  }

  all({store: $store}) {
    return $store.dispatch('apiResult', {
      method: 'GET',
      path: 'api/device-models',
      path_template: '/api/device-models'
    }).then(response => {
      let firmware_key, generations, firmware_category, test_types, device_models = [];

      switch (response.status) {
        case 200:
          ({firmware_key, generations, firmware_category, test_types} = response.data.meta);
          device_models = response.data.data;
          break;
      }
      return {response, result: {device_models, firmware_key, generations, firmware_category, test_types}};
    });
  }

  getDefaultFirmware({store: $store}, firmwareOptionKey, generationConfig, firmwareCategory) {
    return $store.dispatch('apiResult', {
      method: 'GET',
      path: `api/options?name=${encodeURIComponent(firmwareOptionKey)}`,
      path_template: '/api/options',
    }).then(response => {
      let firmwares, firmwaresInDecimal;
      if (response.status === 200) {
        ({firmwares, firmwaresInDecimal} = this.setupFirmware(response.data.data.value, generationConfig, firmwareCategory));
      }
      return {response, result: {firmwares, firmwaresInDecimal}};
    });
  }

  updateDefaultFirmware({store: $store}, firmwareOptionKey, firmwares, generationConfig, firmwareCategory) {
    return $store
      .dispatch(
        'apiResult',
        {
          method: 'PATCH',
          path: `api/options`,
          data: {
            name: firmwareOptionKey,
            value: firmwares,
          },
          path_template: '/api/options',
        }
      ).then(response => {
        let firmwares, firmwaresInDecimal;
        if (response.status === 200) {
          ({firmwares, firmwaresInDecimal} = this.setupFirmware(response.data.data.value, generationConfig, firmwareCategory));
        }
        return {response, result: {firmwares, firmwaresInDecimal}};
      });
  }


  setupFirmware(data, generationConfig, firmwareCategory) {
    let firmwares = {}, firmwaresInDecimal = {};
    for (const [gateway, generations] of Object.entries(generationConfig)) {
      firmwares[gateway] = data?.[gateway] ? Object.assign({}, data[gateway]) : {};
      firmwaresInDecimal[gateway] = data?.[gateway] ? Object.assign({}, data[gateway]) : {};
      for (const [category, {generations: blnApply2Generations}] of Object.entries(firmwareCategory[gateway])) {
        firmwares[gateway][category] = firmwares[gateway]?.[category] ? Object.assign({}, data[gateway][category]) : {};
        firmwaresInDecimal[gateway][category] = firmwaresInDecimal[gateway]?.[category] ? Object.assign({}, data[gateway][category]) : {};
        if(blnApply2Generations) {
          for(let i = 0; i < generations.length; i++) {
            let generation = generations[i];
            let version = firmwares[gateway][category]?.[generation] ? data[gateway][category][generation] : '';
            firmwares[gateway][category][generation] = version;
            firmwaresInDecimal[gateway][category][generation] = version ? parseInt(version.substr(2), 16) : null;
          }
        }
        else {
          let generation = 'n/a';
          let version = firmwares[gateway][category]?.[generation] ? data[gateway][category][generation] : '';
          firmwares[gateway][category][generation] = version;
          firmwaresInDecimal[gateway][category][generation] = version ? parseInt(version.substr(2), 16) : null;
        }
      }
    }

    return {firmwares, firmwaresInDecimal};
  }
}